module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-field form-field__input",
    class: [_vm.rootClasses]
  }, [(_vm.label) ? _c('label', {
    staticClass: "form-field--title-label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-field--input-container",
    attrs: {
      "data-action-count": _vm.actionCount
    }
  }, [(_vm.hasFloatingLabel) ? _c('span', {
    staticClass: "form-field--floating-label",
    attrs: {
      "aria-hidden": "true"
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    ref: "input",
    staticClass: "form-field--input",
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      },
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }, 'input', _vm.inputBindings, false)), _vm._v(" "), _c('div', {
    staticClass: "form-field--actions"
  }, [(_vm.type === 'date') ? _c('button', {
    staticClass: "form-field--action form-field--action__date"
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "calendar",
      "size": "medium"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('cmp-form-field-messages-partial', {
    attrs: {
      "messages": _vm.messages
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5dc9594c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dc9594c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/form/form-field-input/index.vue
// module id = 551
// module chunks = 7